export const BrandLogo = ({
  className = "h-[124px] w-[300px]",
  compact = false,
  imageClassName = "object-contain object-left",
}) => {
  return (
    <span
      className={`inline-flex overflow-hidden rounded-md border border-[#D5DDE5] bg-white p-1.5 ${className}`}
      data-testid="brand-logo-wrapper"
      aria-label="Logo Pragmatic XXI"
    >
      <span
        className={`grid h-full w-full ${compact ? "grid-rows-[0.58fr_1.42fr] gap-0.5" : "grid-rows-[0.52fr_1.48fr] gap-1"}`}
        data-testid="brand-logo-split-layout"
      >
        <img
          src="/logo-pragmatic-wordmark.png"
          alt="Logotipo textual Pragmatic"
          className={`h-full w-full ${imageClassName}`}
          data-testid="brand-logo-wordmark-image"
        />
        <img
          src="/logo-pragmatic-isotypes.png"
          alt="Isotipos XXI y aaS"
          className="h-full w-full object-contain object-left"
          data-testid="brand-logo-isotypes-image"
        />
      </span>
    </span>
  );
};
